import * as Yup from "yup";

export const JourneyGroupSchema = Yup.object().shape({
  name: Yup.string()
    .required("Cadence Category name is required")
    .max(120, ""),
});
